import React from "react";
import { Link } from 'react-router-dom';
import { Progress } from 'reactstrap';
import { useSelector } from "react-redux";

export const QuestionnaireProgress = ({ questionnaire }) => {
    const user = useSelector(state => state.user );

    return (
        <>
            <div className="w-100 d-flex align-items-center justify-content-between border rounded p-3">
                <div className="mr-2 flex-fill">
                    <p className="font-weight-semibold">
                        <span className="pr-1">{questionnaire.name}</span> 
                        {(questionnaire.completion !== 100 || !questionnaire.submitted) &&
                            <span className={questionnaire.completion === 0 ? 'text-orange' : 'text-muted'}>{questionnaire.completion}%</span> 
                        }
                        {questionnaire.completion === 100 && questionnaire.submitted &&
                            <span className="text-green">Completed</span> 
                        }
                    </p>
                    <Progress color="green" value={questionnaire.completion} className="overflow-initial progress-sm" />
                </div>

                <Link to={`/questionnaire/${questionnaire.id}`} className="btn btn-sm btn-outline-green-light">
                    {questionnaire.completion === 0 && <>Start</>}
                    {((questionnaire.completion > 0 && questionnaire.completion < 100)) &&
                        <>Continue</>
                    }
                    {!questionnaire.submitted && questionnaire.completion === 100 &&
                        <>Continue</>
                    }
                    {questionnaire.completion === 100 && questionnaire.submitted && <>View</>}
                </Link>

            </div>
        </>
    )
}